import PropTypes from "prop-types"
import React from "react"

import Chips from "src/components/Chips"
import Form from "src/components/Form"
import OverflowMenu from "src/components/OverflowMenu"

const READ_STATUS_OPTIONS = [
  { value: "read", label: "Read" },
  { value: "unread", label: "Unread" },
]

const TYPE_OPTIONS = [
  { value: "Reservation", label: "Reservation" },
  { value: "ContractQuote", label: "Contract" },
  { value: "Inquiry", label: "Lead" },
  { value: "Waitlist", label: "Waitlist" },
  { value: "LongTermWaitlistEntry", label: "Long-term Waitlist" },
]

const ChatThreadFilters = ({
  readStatus = "all",
  selectedTypes = [],
  onReadStatusChange,
  onTypesChange,
  onReset,
}) => {
  const handleReadStatusToggle = (event) => {
    const { name, checked } = event.target
    // Radio-like behavior: if checking, set to that value; if unchecking, reset to "all"
    onReadStatusChange(checked ? name : "all")
  }

  const handleTypeToggle = (event) => {
    const { name, checked } = event.target
    const updatedTypes = checked
      ? [...selectedTypes, name]
      : selectedTypes.filter((t) => t !== name)
    onTypesChange(updatedTypes)
  }

  const handleRemoveType = (typeToRemove) => {
    onTypesChange(selectedTypes.filter((t) => t !== typeToRemove))
  }

  const getReadStatusLabel = (value) => {
    return READ_STATUS_OPTIONS.find((opt) => opt.value === value)?.label
  }

  const getTypeLabel = (value) => {
    return TYPE_OPTIONS.find((opt) => opt.value === value)?.label
  }

  const hasActiveFilters = readStatus !== "all" || selectedTypes.length > 0

  return (
    <div className="mb-4">
      <div className="flex gap-2">
        <div>
          <OverflowMenu menuButtonLabel="Read Status">
            <div className="space-y-2 p-4">
              {READ_STATUS_OPTIONS.map((option) => (
                <Form.Checkbox
                  key={option.value}
                  name={option.value}
                  label={option.label}
                  checked={readStatus === option.value}
                  onChange={handleReadStatusToggle}
                />
              ))}
            </div>
          </OverflowMenu>
        </div>

        <div>
          <OverflowMenu menuButtonLabel="Type">
            <div className="space-y-2 p-4">
              {TYPE_OPTIONS.map((option) => (
                <Form.Checkbox
                  key={option.value}
                  name={option.value}
                  label={option.label}
                  checked={selectedTypes.includes(option.value)}
                  onChange={handleTypeToggle}
                />
              ))}
            </div>
          </OverflowMenu>
        </div>
      </div>

      {hasActiveFilters && (
        <Chips onReset={onReset}>
          {readStatus !== "all" && (
            <Chips.Chip
              key="read-status"
              text={getReadStatusLabel(readStatus)}
              onClick={() => onReadStatusChange("all")}
            />
          )}
          {selectedTypes.map((type) => (
            <Chips.Chip
              key={type}
              text={getTypeLabel(type)}
              onClick={() => handleRemoveType(type)}
            />
          ))}
        </Chips>
      )}
    </div>
  )
}

ChatThreadFilters.propTypes = {
  readStatus: PropTypes.oneOf(["all", "read", "unread"]),
  selectedTypes: PropTypes.arrayOf(PropTypes.string),
  onReadStatusChange: PropTypes.func.isRequired,
  onTypesChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
}

export default ChatThreadFilters
